<script lang="ts">
  import { navigateTo } from "../lib/routing";
  import { NavigationType, hasPrevPage } from "../lib/stores/session";
  import Button from "./Button.svelte";
  import LeftArrow from "./Icons/LeftArrow.svelte";
  import { getCopy } from "../lib/stores/copy";

  export let customBackHandler: (() => void) | null = null;
  export let isVisible = true;

  const defaultBackHandler = () => navigateTo(NavigationType.Prev);

  $: copy = $getCopy("layout") as Record<string, string>;
  $: backHandler = customBackHandler ?? defaultBackHandler;
</script>

{#if isVisible && ($hasPrevPage || customBackHandler)}
  <Button class="fixed left-4 top-0 lg:relative lg:left-auto lg:top-auto lg:flex lg:z-9 z-11" text on:click={backHandler}>
    <LeftArrow /> <span class="hidden lg:block">{copy.backButtonCopy}</span>
  </Button>
{/if}
